import Swiper from "swiper";

export const createClientCases = () => {
  const container = document.querySelector(".client-cases-carousel .swiper");

  if (container !== null) {
    const swiper = new Swiper(".client-cases-carousel .swiper", {
      speed: 400,
      spaceBetween: 24,
      direction: "horizontal",
      slidesPerView: "auto",
      slidesOffsetBefore: 20,
      breakpoints: {
        768: {
          slidesOffsetBefore: 0,
        },
      },
    });

    const btnPrev = document.querySelector(
      ".section-client-cases [data-carousel-prev]",
    );
    const btnNext = document.querySelector(
      ".section-client-cases [data-carousel-next]",
    );

    btnPrev?.addEventListener("click", () => {
      swiper.slidePrev();
    });

    btnNext?.addEventListener("click", () => {
      swiper.slideNext();
    });
  }
};
